/**
 * 2026-10-16 — 「私訊 Instagram」按鈕(店主要求:香港付款後、中國微信未開通時,
 * 除了官方 LINE 也能選 IG 私訊)。
 *
 * 一律放在 LineAddFriendButton 正下方:同尺寸、同圓角、滿寬,手機上兩顆上下排好按不擠。
 * 連結由 lib/overseasCheckout.js 的 instagramDmUrl() 算好(ig.me/m/帳號 = 直接開私訊);
 * href 空字串就整顆不顯示。沒有 hook,server / client component 都能直接用。
 */
export default function InstagramDmButton({ href, label = "私訊 Instagram" }) {
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="instagram-dm"
      className="transition-opacity hover:opacity-85 active:opacity-75"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        width: "100%",
        minHeight: "44px",
        marginTop: "10px",
        padding: "10px 16px",
        borderRadius: "var(--radius-full, 999px)",
        // IG 品牌漸層底白字(與 LINE 綠並排;8 組主題亮/暗都看得清楚)
        backgroundColor: "#E1306C",
        backgroundImage:
          "linear-gradient(45deg, #F58529 0%, #DD2A7B 45%, #8134AF 75%, #515BD4 100%)",
        color: "#fff",
        fontSize: "15px",
        fontWeight: 700,
        textDecoration: "none",
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
      </svg>
      {label}
    </a>
  );
}
